import { render, staticRenderFns } from "./KidsHome.vue?vue&type=template&id=06dfb284&"
import script from "./KidsHome.vue?vue&type=script&lang=js&"
export * from "./KidsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports